import {
  ALACARTE_REQUEST_GET_BY_ID,
  ALACARTE_REQUEST_GET_BY_ID_SUCCESS,
  ALACARTE_REQUEST_GET_BY_ID_ERROR,
  ALACARTE_REQUEST_GET_LIST,
  ALACARTE_REQUEST_GET_LIST_SUCCESS,
  ALACARTE_REQUEST_GET_LIST_ERROR,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR,

  REQUEST_GET_LIST_DELTA,
  REQUEST_GET_LIST_DELTA_SUCCESS,
  REQUEST_GET_LIST_DELTA_ERROR,
  REQUEST_GET_LIST_WITH_FILTER,
  REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER,
  REQUEST_GET_ALACARTE_LIST_WITH_FILTER,
  REQUEST_GET_ALACARTE_STATUS_FILTER,
  REQUEST_GET_ALACARTE_LIST_WITH_ORDER,
  REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT,
  REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER,
  REQUEST_GET_LIST_WITH_ORDER,
  REQUEST_GET_LIST_SEARCH,
  REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH,
  REQUEST_ADD_ITEM,
  REQUEST_ADD_ITEM_SUCCESS,
  REQUEST_ADD_ITEM_ERROR,
  REQUEST_GET_ITEM,
  REQUEST_GET_ITEM_SUCCESS,
  REQUEST_GET_ITEM_ERROR,
  COMMENT_ADD_ITEM,
  COMMENT_ADD_ITEM_SUCCESS,
  COMMENT_ADD_ITEM_ERROR,
  REQUEST_SELECTED_ITEMS_CHANGE,
  CHANGE_LANGUAGE_FOR_REQUEST_ITEMS,
  SET_IS_TRANSLATION_NEEDED,
  REQUEST_SHOW_TOAST_SET,
  REQUEST_CREATE_QR_IMAGE,
  REQUEST_CREATE_QR_IMAGE_SUCCESS,
  REQUEST_CREATE_QR_IMAGE_ERROR,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR,
  LOL_REQUESTS_WITH_FILTER,
  LOL_REQUESTS_WITH_ORDER,
  LOL_REQUESTS_SEARCH,
  TEMPLATE_ADD_MESSAGE,
  TEMPLATE_ADD_MESSAGE_SUCCESS,
  TEMPLATE_ADD_MESSAGE_ERROR,
  SET_REQUEST_LOADING,
} from "../actions";

import { arrayToObject } from "../../helpers/Utils";

import { addSoftFields } from "./saga";

const INIT_STATE = {
  allRequestItems: {},
  allFastCheckinItems: {},
  allAlacarteItems: {},
  allLolRequestsItems: {},
  lolRequestsItems: [],
  alacarteItems: [],
  requestItems: [],
  fastCheckinItems: [],
  alacarteItemsWithoutFilter: [],
  error: "",
  createQrImageDeepLinkError: "",
  createImageerror: "",
  showToast: false,
  filter: null,
  filterFastCheckin: null,
  filterAlacarte: null,
  filterLolRequests: null,
  filterAlacarteRestaurantSlot: {
    displayValue: [],
    selectedOptions: []
  },
  filterAlacarteRestaurant: null,
  searchKeywordAlacarte: null,
  searchKeywordFastCheckin: "",
  searchKeyword: "",
  loading: false,
  addRequestLoading: false,
  addCommentLoading: false,
  isTranslationNeeded: false,
  createQrImageLoading: false,
  createQrImageDeepLinkLoading: false,
  labels: [{ label: "VIP", color: "secondary" }, { label: "PREMIUM", color: "primary" }, { label: "GOLD", color: "info" }],
  orderColumns: [
    { column: "updated_at", label: "Last Update", direction: "desc" },
    { column: "created_at", label: "Creation Date", direction: "desc" },
    { column: "due_at", label: "Due Date", direction: "asc" }
  ],
  orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" },
  orderColumnFastCheckin: { column: "updated_at", label: "Last Update", direction: "desc" },
  orderColumnAlacarte: { column: "updated_at", label: "Last Update", direction: "desc" },
  orderColumnLolRequests: { column: "updated_at", label: "Last Update", direction: "desc" },
  categories: [],
  selectedItems: [],
  allLoaded: false,
  alacarteAllLoaded: true,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_REQUEST_LOADING: {
      return { ...state, loading: action.payload };
    }

    case ALACARTE_REQUEST_GET_BY_ID: {
      return { ...state };
    }
    case ALACARTE_REQUEST_GET_BY_ID_SUCCESS: {
      let { alacarteRequestList } = action.payload;
      let alacarteRequestListObj = arrayToObject(alacarteRequestList, "id");
      let alacarteItemsObjTemp = { ...state.allAlacarteItems, ...alacarteRequestListObj }
      return {
        ...state,
        alacarteItems: [...Object.values(alacarteItemsObjTemp)],
        alacarteItemsWithoutFilter: [...Object.values(alacarteItemsObjTemp)],
        allAlacarteItems: { ...alacarteItemsObjTemp },
      };
    }
    case ALACARTE_REQUEST_GET_BY_ID_ERROR: {
      return { ...state };
    }
    case ALACARTE_REQUEST_GET_LIST: {
      return { ...state, loading: true };
    }
    case ALACARTE_REQUEST_GET_LIST_SUCCESS: {
      let { alacarteRequestList, alacarteReqListLastEvaluatedKey } = action.payload;
      let alacarteRequestListObj = arrayToObject(alacarteRequestList, "id");
      let alacarteItemsObjTemp = { ...state.allAlacarteItems, ...alacarteRequestListObj }

      return {
        ...state,
        alacarteItems: [...Object.values(alacarteItemsObjTemp)],
        alacarteItemsWithoutFilter: [...Object.values(alacarteItemsObjTemp)],
        allAlacarteItems: { ...alacarteItemsObjTemp },
        alacarteReqListLastEvaluatedKey,
        alacarteAllLoaded: alacarteReqListLastEvaluatedKey ? false : true,
        loading: false
      };
    }
    case ALACARTE_REQUEST_GET_LIST_ERROR: {
      return { ...state, loading: false };
    }

    case ALACARTE_REQUEST_GET_LIST_WITH_FILTER: {
      const { selectedOptions, displayValue, value } = action.payload;
      if (value !== "") {
        const selectedValue = displayValue[0];
        const [day, month, year] = selectedOptions[1].label.split("/").map(Number);
        const filteredItems = state.alacarteItemsWithoutFilter.filter(res => {
          const valueComparisionBoolean = res.custom_fields_values.some(value => value.value.includes(selectedValue));
          const date = new Date(res.due_at * 1000);
          return valueComparisionBoolean && date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year;
        });
        return {
          ...state,
          alacarteItems: filteredItems,
          loading: true,
          filterAlacarteRestaurantSlot: {
            value,
            displayValue,
            selectedOptions
          }
        };
      }
      return { ...state };
    }
    case ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS: {
      let { filteredAlacarteRequestList, selectedOptions, displayValue, value } = action.payload;
      if (action.payload && action.payload.value && action.payload.value !== "") {
        let filteredAlacarteRequestListObj = arrayToObject(filteredAlacarteRequestList, "id");
        return {
          ...state,
          loading: false,
          alacarteItems: [...Object.values(filteredAlacarteRequestListObj)],
          alacarteItemsWithoutFilter: [...Object.values({ ...state.allAlacarteItems, ...filteredAlacarteRequestListObj })],
          allAlacarteItems: { ...state.allAlacarteItems, ...filteredAlacarteRequestListObj },
          filterAlacarteRestaurantSlot: {
            value,
            displayValue,
            selectedOptions
          },
          searchKeywordAlacarte: ""
        };
      }
      return {
        ...state,
        loading: false,
        alacarteItems: [...Object.values(state.alacarteItemsWithoutFilter)],
        filterAlacarteRestaurantSlot: {
          displayValue,
          selectedOptions
        },
        searchKeywordAlacarte: ""
      };
    }
    case ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR: {
      return { ...state, loading: false };
    }


    case REQUEST_GET_LIST_DELTA:
      return { ...state, loading: true };

    case REQUEST_GET_LIST_DELTA_SUCCESS: {
      const { items, allLoaded } = action.payload;
      if (items.length > 0) {
        let allRequestItemsObj = {};
        let allFastCheckinItemsObj = {};
        let allLolRequestsItemsObj = {};

        if (items instanceof Array) {
          const allFastCheckinRequestItems = items.filter(res => {
            return res.service_type === "FAST_CHECK_IN";
          });

          const allAlacarteRequestItems = items.filter(res => {
            return res.service_type === "ALACARTE_RESTAURANT_RESERVATION" && res.reservation_status === "RESERVED";
          });

          const allLolRequestsItems = items.filter(res => {
            return res.service_type === "LOL_REQUEST";
          });

          allRequestItemsObj = arrayToObject(items, "id");
          allFastCheckinItemsObj = arrayToObject(allFastCheckinRequestItems, "id");
          allLolRequestsItemsObj = arrayToObject(allLolRequestsItems, "id");
        }

        allRequestItemsObj = { ...state.allRequestItems, ...allRequestItemsObj };
        allFastCheckinItemsObj = { ...state.allFastCheckinItems, ...allFastCheckinItemsObj };
        allLolRequestsItemsObj = { ...state.allLolRequestsItems, ...allLolRequestsItemsObj };

        const categories = Object.values(
          arrayToObject(
            Object.values(allRequestItemsObj).map(item => {
              return { serviceName: item.serviceName, serviceId: item.service_id, service_type: item.service_type };
            }),
            "serviceId"
          )
        );
        // "service_type": "FAST_CHECK_IN",
        const categoriesFilterForFastCheckin = categories.filter(res => res.service_type !== "FAST_CHECK_IN");

        return {
          ...state,
          loading: false,
          addRequestLoading: false,
          allRequestItems: { ...allRequestItemsObj },
          allFastCheckinItems: { ...allFastCheckinItemsObj },
          requestItems: [...Object.values(allRequestItemsObj)],
          fastCheckinItems: [...Object.values(allFastCheckinItemsObj)],
          allLolRequestsItems: { ...allLolRequestsItemsObj },
          lolRequestsItems: [...Object.values(allLolRequestsItemsObj)],
          categories: categoriesFilterForFastCheckin,
          searchKeyword: null
        };
      }
      return {
        ...state,
        loading: false,
        addRequestLoading: false,
        allLoaded
      };
    }

    case REQUEST_GET_LIST_DELTA_ERROR:
      return { ...state, loading: false, error: action.payload };

    case REQUEST_GET_LIST_WITH_FILTER: {
      if (action.payload.column === "" || action.payload.value === "") {
        return {
          ...state,
          requestItems: [...Object.values(state.allRequestItems)],
          filter: null,
          searchKeyword: ""
        };
      }

      const filteredItems = Object.keys(state.allRequestItems).reduce((r, e) => {
        const toReturn = r;
        if (state.allRequestItems[e][action.payload.column] === action.payload.value) toReturn[e] = state.allRequestItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        requestItems: [...Object.values(filteredItems)],
        filter: {
          column: action.payload.column,
          value: action.payload.value
        },
        searchKeyword: ""
      };
    }

    case REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER: {
      // alert(`${JSON.stringify(action.payload)}`);
      // alert(`state fılter ${JSON.stringify(state.filter)}`);
      if (action.payload.column === "" || action.payload.value === "") {
        return {
          ...state,
          // loading: true,
          fastCheckinItems: [...Object.values(state.allFastCheckinItems)],
          filterFastCheckin: null,
          searchKeywordFastCheckin: ""
        };
      }

      const filteredItems = Object.keys(state.allFastCheckinItems).reduce((r, e) => {
        const toReturn = r;
        if (state.allFastCheckinItems[e][action.payload.column] === action.payload.value) toReturn[e] = state.allFastCheckinItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        fastCheckinItems: [...Object.values(filteredItems)],
        filterFastCheckin: {
          column: action.payload.column,
          value: action.payload.value
        },
        searchKeywordFastCheckin: ""
      };
    }

    case REQUEST_GET_ALACARTE_STATUS_FILTER: {
      if (action.payload.column === "" || action.payload.value === "") {
        return {
          ...state,
          alacarteItems: [...Object.values(state.allAlacarteItems)],
          alacarteItemsWithoutFilter: [...Object.values(state.allAlacarteItems)],
          filterAlacarte: null
        };
      }

      const alacarteFilteredItems = Object.keys(state.allAlacarteItems).reduce((r, e) => {
        const toReturn = r;
        if (state.allAlacarteItems[e][action.payload.column] === action.payload.value) toReturn[e] = state.allAlacarteItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        alacarteItems: [...Object.values(alacarteFilteredItems)],
        alacarteItemsWithoutFilter: [...Object.values(alacarteFilteredItems)],
        // requestItems: [...Object.values(filteredItems)],
        filterAlacarte: {
          column: action.payload.column,
          value: action.payload.value
        }
      };
    }

    case REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT: {
      if (action.payload && action.payload.column && action.payload.column !== "" && action.payload.value && action.payload.value !== "") {
        const filteredItems = state.alacarteItemsWithoutFilter.filter(res => {
          return res.reservation_id.indexOf(action.payload.value) !== -1;
        });

        return {
          ...state,
          // loading: true,
          alacarteItems: [...Object.values(filteredItems)],
          // filterAlacarteRestaurantSlot: {
          //   value: action.payload.value
          // },
          filterAlacarteRestaurant: {
            column: action.payload.column,
            value: action.payload.value
          },
          searchKeywordAlacarte: ""
        };
      }
      return {
        ...state,
        // loading: true,
        alacarteItems: [...Object.values(state.alacarteItemsWithoutFilter)],
        // filterAlacarteRestaurantSlot: null,
        filterAlacarteRestaurant: null,
        searchKeywordAlacarte: ""
      };
    }

    case REQUEST_GET_ALACARTE_LIST_WITH_FILTER: {
      if (action.payload && action.payload.value && action.payload.value !== "") {
        let filteredItems = [];
        if (action.payload && action.payload.filterWithDate && action.payload.filterWithDate === true) {
          const selectedValue = action.payload.displayValue[0];
          const [day, month, year] = action.payload.selectedOptions[1].label.split("/").map(Number);

          filteredItems = state.alacarteItemsWithoutFilter.filter(res => {
            const valueComparisionBoolean = res.custom_fields_values.some(value => value.value.includes(selectedValue));
            const date = new Date(res.due_at * 1000);

            return valueComparisionBoolean && date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year;
          });
        } else {
          filteredItems = state.alacarteItemsWithoutFilter.filter(res => {
            return res.reservation_id === action.payload.value;
          });
        }
        return {
          ...state,
          // loading: true,
          alacarteItems: [...Object.values(filteredItems)],
          filterAlacarteRestaurantSlot: {
            value: action.payload.value,
            displayValue: action.payload.displayValue,
            selectedOptions: action.payload.selectedOptions
          },
          searchKeywordAlacarte: ""
        };
      }
      return {
        ...state,
        // loading: true,
        alacarteItems: [...Object.values(state.alacarteItemsWithoutFilter)],
        filterAlacarteRestaurantSlot: {
          displayValue: action.payload.displayValue,
          selectedOptions: action.payload.selectedOptions
        },
        searchKeywordAlacarte: ""
      };
    }

    case REQUEST_GET_LIST_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          // loading: true,
          requestItems: state.requestItems,
          orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }

      const sortedItems =
        action.payload.direction === "asc"
          ? state.requestItems.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.requestItems.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });

      return {
        ...state,
        // loading: true,
        requestItems: sortedItems,
        orderColumn: state.orderColumns.find(x => x.column === action.payload.column)
      };
    }

    case REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          // loading: true,
          fastCheckinItems: state.fastCheckinItems,
          orderColumnFastCheckin: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }

      const sortedItems =
        action.payload.direction === "asc"
          ? state.fastCheckinItems.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.fastCheckinItems.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });

      return {
        ...state,
        fastCheckinItems: sortedItems,
        orderColumnFastCheckin: state.orderColumns.find(x => x.column === action.payload.column)
      };
    }

    case REQUEST_GET_ALACARTE_LIST_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          alacarteItems: state.alacarteItems,
          alacarteItemsWithoutFilter: state.alacarteItemsWithoutFilter,
          orderColumnAlacarte: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const sortedAlacarteItems =
        action.payload.direction === "asc"
          ? state.alacarteItems.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.alacarteItems.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });
      const sortedAlacarteWithoutFilterItems =
        action.payload.direction === "asc"
          ? state.alacarteItemsWithoutFilter.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.alacarteItemsWithoutFilter.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });

      return {
        ...state,
        // loading: true,
        alacarteItems: sortedAlacarteItems,
        alacarteItemsWithoutFilter: sortedAlacarteWithoutFilterItems,
        // orderColumnAlacarte: state.orderColumns.find(x => x.column === action.payload.column)
        orderColumnAlacarte: { column: "updated_at", label: "Last Update", direction: "desc" }
      };
    }

    case REQUEST_GET_LIST_SEARCH: {
      if (action.payload === "") {
        return {
          ...state,
          searchKeyword: null,
          requestItems: [...Object.values(state.allRequestItems)],
          filter: null,
          orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const keyword = action.payload.toLowerCase();

      const searchItems = Object.keys(state.allRequestItems).reduce((r, e) => {
        const toReturn = r;
        if (
          (state.allRequestItems[e].title && state.allRequestItems[e].title.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].staff_summary && state.allRequestItems[e].staff_summary.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].status && state.allRequestItems[e].status.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].service &&
            state.allRequestItems[e].service.name &&
            state.allRequestItems[e].service.name.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].fullName && state.allRequestItems[e].fullName.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].label && state.allRequestItems[e].label.toLowerCase().indexOf(keyword) > -1) ||
          (state.allRequestItems[e].rooms &&
            state.allRequestItems[e].rooms
              .join(" ")
              .toLowerCase()
              .indexOf(keyword) > -1)
        )
          toReturn[e] = state.allRequestItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        requestItems: [...Object.values(searchItems)],
        searchKeyword: action.payload,
        filter: null,
        orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
      };
    }

    case REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH: {
      if (action.payload === "") {
        return {
          ...state,
          searchKeywordFastCheckin: null,
          fastCheckinItems: [...Object.values(state.allFastCheckinItems)],
          filterFastCheckin: null,
          orderColumnFastCheckin: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const keyword = action.payload.toLowerCase();

      const searchItems = Object.keys(state.allFastCheckinItems).reduce((r, e) => {
        const toReturn = r;
        if (
          (state.allFastCheckinItems[e].title && state.allFastCheckinItems[e].title.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].staff_summary && state.allFastCheckinItems[e].staff_summary.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].status && state.allFastCheckinItems[e].status.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].service &&
            state.allFastCheckinItems[e].service.name &&
            state.allFastCheckinItems[e].service.name.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].fullName && state.allFastCheckinItems[e].fullName.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].label && state.allFastCheckinItems[e].label.toLowerCase().indexOf(keyword) > -1) ||
          (state.allFastCheckinItems[e].rooms &&
            state.allFastCheckinItems[e].rooms
              .join(" ")
              .toLowerCase()
              .indexOf(keyword) > -1)
        )
          toReturn[e] = state.allFastCheckinItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        fastCheckinItems: [...Object.values(searchItems)],
        searchKeywordFastCheckin: action.payload,
        filterFastCheckin: null,
        orderColumnFastCheckin: { column: "updated_at", label: "Last Update", direction: "desc" }
      };
    }

    case REQUEST_ADD_ITEM:
      return { ...state, addRequestLoading: true };

    case REQUEST_ADD_ITEM_SUCCESS: {
      let allRequestItemsObj = { ...state.allRequestItems }
      let allFastCheckinItemsObj = { ...state.allFastCheckinItems }
      let allLolRequestsItemsObj = { ...state.allLolRequestsItems }

      if (state.allRequestItems[action.payload.id]
        || (action.payload.service_type && action.payload.service_type !== "ALACARTE_RESTAURANT_RESERVATION")) {
        /** PATCH REQUEST */
        allRequestItemsObj = {
          ...state.allRequestItems,
          [action.payload.id]: { ...state.allRequestItems[action.payload.id], ...action.payload }
        };

        /** PATCH FAST_CHECKIN */
        allFastCheckinItemsObj = {
          ...state.allFastCheckinItems,
          [action.payload.id]: { ...state.allFastCheckinItems[action.payload.id], ...action.payload }
        };

        /** PATCH LOL_REQUEST */
        allLolRequestsItemsObj = {
          ...state.allLolRequestsItems,
          [action.payload.id]: { ...state.allLolRequestsItems[action.payload.id], ...action.payload }
        };
      }

      let allAlacarteItemsObj = { ...state.allAlacarteItems }
      if (state.allAlacarteItems[action.payload.id] || action.payload.service_type === "ALACARTE_RESTAURANT_RESERVATION") {
        /** PATCH ALACARTE */
        allAlacarteItemsObj = {
          ...state.allAlacarteItems,
          [action.payload.id]: { ...state.allAlacarteItems[action.payload.id], ...action.payload }
        };
      }

      return {
        ...state,
        addRequestLoading: false,
        allAlacarteItems: { ...allAlacarteItemsObj },
        allRequestItems: { ...allRequestItemsObj },
        requestItems: [...Object.values(allRequestItemsObj)],
        allLolRequestsItems: { ...allLolRequestsItemsObj },
        lolRequestsItems: [...Object.values(allLolRequestsItemsObj)],
        allFastCheckinItems: { ...allFastCheckinItemsObj },
        fastCheckinItems: [...Object.values(allFastCheckinItemsObj)],
        alacarteItems: [...Object.values(allAlacarteItemsObj)],
        alacarteItemsWithoutFilter: [...Object.values(allAlacarteItemsObj)]
      };
    }

    case REQUEST_ADD_ITEM_ERROR:
      return {
        ...action.payload.snapshot,
        loading: true,
        error: action.payload.error,
        addRequestLoading: false,
        showToast: true
      };

    case COMMENT_ADD_ITEM:
      return { ...state, addCommentLoading: true };

    case COMMENT_ADD_ITEM_SUCCESS: {
      return {
        ...state,
        addCommentLoading: false
      };
    }

    case COMMENT_ADD_ITEM_ERROR:
      return { ...action.payload.snapshot, addCommentLoading: false, error: action.payload.error, showToast: true };

    case "UPDATE_TEMP_MESSAGE":
      return { ...state, TempMessageLoading: true };

    case "UPDATE_TEMP_MESSAGE_SUCCESS": {
      return {
        ...state,
        TempMessageLoading: false
      };
    }

    case "UPDATE_TEMP_MESSAGE_ERROR":
      return { ...action.payload.snapshot, TempMessageLoading: false, error: action.payload.error, showToast: true };

    case "PUT_TEMP_MESSAGE":
      return { ...state, TempMessageLoading: true };

    case "PUT_TEMP_MESSAGE_SUCCESS": {
      return {
        ...state,
        TempMessageLoading: false
      };
    }

    case "PUT_TEMP_MESSAGE_ERROR":
      return { ...action.payload.snapshot, TempMessageLoading: false, error: action.payload.error, showToast: true };

    case "TEMPLATE_ADD_MESSAGE":
      return { ...state, TempMessageLoading: true };

    case "TEMPLATE_ADD_MESSAGE_SUCCESS": {
      return {
        ...state,
        TempMessageLoading: false
      };
    }

    case "TEMPLATE_ADD_MESSAGE_ERROR":
      return { ...action.payload.snapshot, TempMessageLoading: false, error: action.payload.error, showToast: true };

    case REQUEST_GET_ITEM:
      return { ...state, loading: false };

    case REQUEST_GET_ITEM_SUCCESS: {
      const allRequestItemsObj = {
        ...state.allRequestItems,
        [action.payload.id]: { ...state.allRequestItems[action.payload.id], ...action.payload }
      };
      return {
        ...state,
        loading: true,
        allRequestItems: { ...allRequestItemsObj },
        requestItems: [...Object.values(allRequestItemsObj)]
      };
    }
    case REQUEST_GET_ITEM_ERROR:
      return { ...state, loading: true, error: action.payload };

    case "TEMPLATE_GET_ITEM":
      return { ...state, loading: true, templateMessages: null };

    case "TEMPLATE_GET_ITEM_SUCCES": {
      return {
        ...state,
        loading: false, // action.payload
        templateMessages: action.payload
      };
    }
    case "TEMPLATE_GET_ITEM_ERROR":
      return { ...state, loading: false, error: action.payload };

    case CHANGE_LANGUAGE_FOR_REQUEST_ITEMS: {
      const allFastCheckinItemsArrInLocale = Object.values(state.allFastCheckinItems).map(request => {
        const { locale, timeZone } = action.payload;
        return addSoftFields(request, locale, timeZone);
      });
      const allFastCheckinItemsObjLocale = arrayToObject(allFastCheckinItemsArrInLocale, "id");

      const allAlacarteItemsArrInLocale = Object.values(state.allAlacarteItems).map(request => {
        const { locale, timeZone } = action.payload;
        return addSoftFields(request, locale, timeZone);
      });
      const allAlacarteItemsObjLocale = arrayToObject(allAlacarteItemsArrInLocale, "id");

      const allLolRequestsItemsArrInLocale = Object.values(state.allLolRequestsItems).map(request => {
        const { locale, timeZone } = action.payload;
        return addSoftFields(request, locale, timeZone);
      });
      const allLolRequestsItemsObjLocale = arrayToObject(allLolRequestsItemsArrInLocale, "id");

      const allRequestItemsArrInLocale = Object.values(state.allRequestItems).map(request => {
        const { locale, timeZone } = action.payload;
        return addSoftFields(request, locale, timeZone);
      });
      const allRequestItemsObjLocale = arrayToObject(allRequestItemsArrInLocale, "id");

      const categories = Object.values(
        arrayToObject(
          allRequestItemsArrInLocale.map(item => {
            return { serviceName: item.serviceName, serviceId: item.service_id, service_type: item.service_type };
          }),
          "serviceId"
        )
      );
      const categoriesFilterForFastCheckin = categories.filter(res => res.service_type !== "FAST_CHECK_IN");

      return {
        ...state,
        allFastCheckinItems: allFastCheckinItemsObjLocale,
        fastCheckinItems: [...Object.values(allFastCheckinItemsObjLocale)],
        allAlacarteItems: allAlacarteItemsObjLocale,
        alacarteItems: [...Object.values(allAlacarteItemsObjLocale)],
        allLolRequestsItems: allLolRequestsItemsArrInLocale,
        lolRequestsItems: [...Object.values(allLolRequestsItemsObjLocale)],
        allRequestItems: allRequestItemsObjLocale,
        requestItems: [...Object.values(allRequestItemsObjLocale)],
        categories: categoriesFilterForFastCheckin
      };
    }

    case REQUEST_SELECTED_ITEMS_CHANGE:
      return { ...state, selectedItems: action.payload };

    case SET_IS_TRANSLATION_NEEDED:
      return { ...state, isTranslationNeeded: action.payload };
    case REQUEST_SHOW_TOAST_SET:
      return { ...state, showToast: action.payload };

    case REQUEST_CREATE_QR_IMAGE:
      return { ...state, createQrImageLoading: true, shortener: null };
    case REQUEST_CREATE_QR_IMAGE_SUCCESS: {
      const url = new URL(action.payload.data?.body?.url_long);
      const source = url.searchParams.get('source');
      if (source == "email" || source == "sms") {
        return {
          ...state,
          createQrImageLoading: false,
          shortener: action.payload,
          createImageerror: ""
        };
      }
      return {
        ...state,
        createQrImageLoading: false,
        createImage: action.payload,
        createImageerror: ""
      };
    }
    case REQUEST_CREATE_QR_IMAGE_ERROR:
      // console.error('create qr ımage action error:', action);
      return { ...state, createQrImageLoading: false, createImageerror: action.payload };

    case REQUEST_CREATE_QR_IMAGE_DEEP_LINK:
      return { ...state, createQrImageDeepLinkLoading: true };
    case REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS: {
      return {
        ...state,
        createQrImageDeepLinkLoading: false,
        createQrImageDeepLink: action.payload,
        createQrImageDeepLinkError: ""
      };
    }
    case REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR:
      return { ...state, createQrImageDeepLinkLoading: false, createQrImageDeepLinkError: action.payload };

    case LOL_REQUESTS_WITH_FILTER: {
      if (action.payload.column === "" || action.payload.value === "") {
        return {
          ...state,
          lolRequestsItems: [...Object.values(state.allLolRequestsItems)],
          filterLolRequests: null,
          searchKeywordLolRequests: ""
        };
      }

      // const filteredItems = Object.keys(state.allLolRequestsItems).filter(item => {
      //   return item[action.payload.column] === item[action.payload.value];
      // });

      const filteredItems = Object.keys(state.allLolRequestsItems).reduce((r, e) => {
        const toReturn = r;
        if (state.allLolRequestsItems[e][action.payload.column] === action.payload.value) toReturn[e] = state.allLolRequestsItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        lolRequestsItems: [...Object.values(filteredItems)],
        filterLolRequests: {
          column: action.payload.column,
          value: action.payload.value
        },
        searchKeywordLolRequests: ""
      };
    }

    case LOL_REQUESTS_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          lolRequestsItems: state.lolRequestsItems,
          orderColumnLolRequests: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const sortedItems =
        action.payload.direction === "asc"
          ? state.lolRequestsItems.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.lolRequestsItems.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });

      return {
        ...state,
        lolRequestsItems: sortedItems,
        orderColumnLolRequests: state.orderColumns.find(x => x.column === action.payload.column)
      };
    }

    case LOL_REQUESTS_SEARCH: {
      if (action.payload === "") {
        return {
          ...state,
          searchKeywordLolRequests: null,
          lolRequestsItems: [...Object.values(state.allLolRequestsItems)],
          filterLolRequests: null,
          orderColumnLolRequests: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const keyword = action.payload.toLowerCase();

      const searchItems = Object.keys(state.allLolRequestsItems).reduce((r, e) => {
        const toReturn = r;
        if (
          (state.allLolRequestsItems[e].title && state.allLolRequestsItems[e].title.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].staff_summary && state.allLolRequestsItems[e].staff_summary.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].status && state.allLolRequestsItems[e].status.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].service &&
            state.allLolRequestsItems[e].service.name &&
            state.allLolRequestsItems[e].service.name.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].fullName && state.allLolRequestsItems[e].fullName.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].label && state.allLolRequestsItems[e].label.toLowerCase().indexOf(keyword) > -1) ||
          (state.allLolRequestsItems[e].rooms &&
            state.allLolRequestsItems[e].rooms
              .join(" ")
              .toLowerCase()
              .indexOf(keyword) > -1)
        )
          toReturn[e] = state.allLolRequestsItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        lolRequestsItems: [...Object.values(searchItems)],
        searchKeywordLolRequests: action.payload,
        filterLolRequests: null,
        orderColumnLolRequests: { column: "updated_at", label: "Last Update", direction: "desc" }
      };
    }

    default:
      return state;
  }
};
